module.exports = __webpack_public_path__ + "static/media/grin.c178ee89.svg";